<h2 class="pb-[2.5rem]">{{ 'mobility.title' | transloco }}</h2>
@if(loading()){
<div class="my-[6.25rem]"><loader /></div>
} @else {
<div class="mb-10 flex flex-row-reverse">
  @if(userRole()!="User"){
  <toggle
    [isActive]="modeDraft()"
    (toggleChange)="toggleDraftMode()"
    [text]="'components.toggle.showPendingTiles' | transloco"
    class="self-end"
  ></toggle>
  }
</div>
<div class="flex flex-col gap-[2.5rem] bg-white rounded-3xl mb-[2.5rem]">
  <div class="p-[1.5rem] pb-0">
    <h3 id="discover-our-jobs">{{ 'mobility.discoverOurJobs' | transloco }}</h3>
  </div>
  <div class="bento-in-section md:p-[1.5rem] md:pt-0">
    @for (tile of tilesDiscoverToShow(); track tile.id ?? $index) {
    <app-tile
      [id]="tile.id"
      [title]="tile.title"
      [text]="tile.text"
      [variant]="tile.variant"
      [ctaText]="tile.ctaText | transloco"
      [ctaLink]="tile.ctaLink"
      [image]="tile.image"
      [size]="tile.size"
      [textDisclaimer]="tile.textDisclaimer"
      [isRedirectionExternal]="tile.isExternalLink"
      [status]="tile.status"
    ></app-tile>
    }
  </div>
</div>

<div class="flex flex-col gap-[2.5rem] bg-white rounded-3xl mb-[2.5rem]">
  <div class="p-[1.5rem] pb-0">
    <h3 id="mobility-project-exchange">
      {{ 'mobility.mobilityProjectExchange' | transloco }}
    </h3>
  </div>
  <div class="bento-in-section md:p-[1.5rem] md:pt-0">
    @for (tile of tilesDiscussToShow(); track tile.id ?? $index) {
    <app-tile
      [id]="tile.id"
      [title]="tile.title"
      [text]="tile.text"
      [variant]="tile.variant"
      [ctaText]="tile.ctaText | transloco"
      [ctaLink]="tile.ctaLink"
      [image]="tile.image"
      [size]="tile.size"
      [textDisclaimer]="tile.textDisclaimer"
      [isRedirectionExternal]="tile.isExternalLink"
      [status]="tile.status"
    ></app-tile>
    }
  </div>
</div>

<div class="flex flex-col gap-[2.5rem] bg-white rounded-3xl mb-[2.5rem]">
  <div class="p-[1.5rem] pb-0">
    <h3 id="mobility-offer-application">
      {{ 'mobility.mobilityOfferApplication' | transloco }}
    </h3>
  </div>
  <div class="bento-in-section md:p-[1.5rem] md:pt-0">
    @for (tile of tilesApplyToShow(); track tile.id ?? $index) {
    <app-tile
      [id]="tile.id"
      [title]="tile.title"
      [text]="tile.text"
      [variant]="tile.variant"
      [ctaText]="tile.ctaText | transloco"
      [ctaLink]="tile.ctaLink"
      [image]="tile.image"
      [size]="tile.size"
      [textDisclaimer]="tile.textDisclaimer"
      [isRedirectionExternal]="tile.isExternalLink"
      [status]="tile.status"
    ></app-tile>
    }
  </div>
</div>
}

<app-favorite-tile-error-modal />
